'use client'
import React from 'react'
import styles from './styles.module.scss'
import { useBackground } from './useBackground'
import { useBorder } from './useBorder'

import { LoadingSpinner } from '../../Loaders'
import { TEXT } from '../Button.type'
import { COLOR, VARIANT } from './types'

interface FixedButtonProps {
  width?: string
  maxWidth?: string
  minWidth?: string
  height?: string
  color?: COLOR
  variant?: VARIANT
  disabled?: boolean
  text?: TEXT
  children: React.ReactNode
  onClick?: (e: any) => void
  loading?: boolean
  type?: 'submit' | 'button'
  borderWidth?: string
  className?: string
  fontWeight?: string
}

const FixedButton: React.FC<FixedButtonProps> = ({
  className,
  children,
  loading = false,
  disabled = false,
  variant = 'contain',
  text,
  width = '100%',
  maxWidth = '200px',
  minWidth = 'none',
  height = '40px',
  color = 'gradient',
  borderWidth = '1px',
  fontWeight = 'initial',
  ...props
}) => {
  const textClassName = text === 'upper' ? styles['upper'] : ''
  const colorClassName = color !== 'trans' ? styles[color] : ''
  const backgroundClassName = useBackground(color, variant)
  const borderClassName = useBorder(color, variant)

  return (
    <div className={styles.buttonWrapper} style={{ width, maxWidth }}>
      <button
        className={`${
          styles.btn
        } ${variant} ${colorClassName} ${textClassName} ${
          styles[borderClassName]
        } ${styles[backgroundClassName]} ${className ? className : ''}`}
        style={{ height, width, maxWidth, borderWidth, minWidth, fontWeight }}
        disabled={loading || disabled}
        {...props}
      >
        {children}
      </button>
      {loading && (
        <div className={styles.spinnerContainer}>
          <LoadingSpinner size="sm" />
        </div>
      )}
    </div>
  )
}

export default FixedButton
